<template>
  <modern-pie-chart
    v-if="dataLoaded"
    :title="title"
    :series="series"
    :labels="labels"
    :colors="chartColors"
    :height="300"
    :show-donut="false"
    :show-data-labels="true"
    :show-legend="true"
    :display-mode="displayMode"
  />
  <div v-else class="loading-message">
    <p>Carregando...</p>
  </div>
</template>

<script>
import { companyClassificationChart } from "@/api/charts";
import { colors } from "./commons";
import { mapGetters } from "vuex";
import ModernPieChart from "./ModernPieChart.vue";
import { displayModeMixin } from "./displayModeMixin";

export default {
  name: "ClassificationChart",
  mixins: [displayModeMixin],
  components: {
    ModernPieChart,
  },
  props: {
    company: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    classification: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      series: [],
      labels: [],
      chartColors: [],
      dataLoaded: false,
    };
  },

  computed: {
    ...mapGetters(["classificationMaps"]),
  },

  async created() {
    try {
      const response = await companyClassificationChart(
        this.company,
        this.type,
        this.classification
      );
      const data = response.data;

      // Validar se os dados existem e são um array
      if (!data || !Array.isArray(data) || data.length === 0) {
        this.series = [];
        this.labels = [];
        this.chartColors = colors.default();
        return;
      }

      // Validar se classificationMaps existe
      if (
        !this.classificationMaps ||
        !this.classificationMaps[this.classification]
      ) {
        this.series = [];
        this.labels = [];
        this.chartColors = colors.default();
        return;
      }

      let includeNullColor = false;

      for (const item of data) {
        if (!item || typeof item.count === "undefined") {
          continue; // Pular itens inválidos
        }

        if (item._id === null) {
          this.labels.unshift("Sem Classificação");
          this.series.unshift(item.count || 0);
          includeNullColor = true;
        } else {
          const label = this.classificationMaps[this.classification][item._id];
          if (label) {
            this.labels.push(label);
            this.series.push(item.count || 0);
          }
        }
      }

      this.chartColors = colors.default(includeNullColor);
      this.dataLoaded = true;
    } catch (error) {
      this.series = [];
      this.labels = [];
      this.chartColors = colors.default();
      this.dataLoaded = true;
    }
  },
};
</script>
<style scoped>
.loading-message {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #94a3b8;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  font-size: 14px;
}
</style>
